// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardRouteImport } from './routes/_dashboard'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as DashboardAnalyticsRouteImport } from './routes/_dashboard.analytics'
import { Route as DashboardAuditRouteImport } from './routes/_dashboard.audit'
import { Route as DashboardCustomersRouteImport } from './routes/_dashboard.customers'
import { Route as DashboardDashboardRouteImport } from './routes/_dashboard.dashboard'
import { Route as DashboardDeliveriesRouteImport } from './routes/_dashboard.deliveries'
import { Route as DashboardDevicesRouteImport } from './routes/_dashboard.devices'
import { Route as DashboardDynamicIslandRouteImport } from './routes/_dashboard.dynamic-island'
import { Route as DashboardReportsRouteImport } from './routes/_dashboard.reports'
import { Route as DashboardSalesRouteImport } from './routes/_dashboard.sales'
import { Route as DashboardShiftsRouteImport } from './routes/_dashboard.shifts'
import { Route as DashboardTerminalRouteImport } from './routes/_dashboard.terminal'
import { Route as AuthSlugRouteImport } from './routes/auth.$slug'
import { Route as PayLinkTokenRouteImport } from './routes/pay-link.$token'
import { Route as DashboardAnalyticsIndexRouteImport } from './routes/_dashboard.analytics.index'
import { Route as DashboardAnalyticsCashRouteImport } from './routes/_dashboard.analytics.cash'
import { Route as DashboardAnalyticsComplianceRouteImport } from './routes/_dashboard.analytics.compliance'
import { Route as DashboardAnalyticsCustomersRouteImport } from './routes/_dashboard.analytics.customers'
import { Route as DashboardAnalyticsInventoryRouteImport } from './routes/_dashboard.analytics.inventory'
import { Route as DashboardAnalyticsProfitabilityRouteImport } from './routes/_dashboard.analytics.profitability'
import { Route as DashboardAnalyticsSalesRouteImport } from './routes/_dashboard.analytics.sales'
import { Route as DashboardCatalogBrandsRouteImport } from './routes/_dashboard.catalog.brands'
import { Route as DashboardCatalogClassificationsRouteImport } from './routes/_dashboard.catalog.classifications'
import { Route as DashboardCatalogPricingRouteImport } from './routes/_dashboard.catalog.pricing'
import { Route as DashboardCatalogProductsRouteImport } from './routes/_dashboard.catalog.products'
import { Route as DashboardCatalogStrainsRouteImport } from './routes/_dashboard.catalog.strains'
import { Route as DashboardCatalogSuppliersRouteImport } from './routes/_dashboard.catalog.suppliers'
import { Route as DashboardCatalogTagsRouteImport } from './routes/_dashboard.catalog.tags'
import { Route as DashboardCustomersIndexRouteImport } from './routes/_dashboard.customers.index'
import { Route as DashboardCustomersItemRouteImport } from './routes/_dashboard.customers.$item'
import { Route as DashboardDevicesAgentsRouteImport } from './routes/_dashboard.devices.agents'
import { Route as DashboardDevicesJobsRouteImport } from './routes/_dashboard.devices.jobs'
import { Route as DashboardDevicesPrintersRouteImport } from './routes/_dashboard.devices.printers'
import { Route as DashboardDevicesTemplatesRouteImport } from './routes/_dashboard.devices.templates'
import { Route as DashboardInventoryAdjustmentsRouteImport } from './routes/_dashboard.inventory.adjustments'
import { Route as DashboardInventoryPackagesRouteImport } from './routes/_dashboard.inventory.packages'
import { Route as DashboardInventoryReconciliationRouteImport } from './routes/_dashboard.inventory.reconciliation'
import { Route as DashboardInventoryStockRouteImport } from './routes/_dashboard.inventory.stock'
import { Route as DashboardInventoryTransfersRouteImport } from './routes/_dashboard.inventory.transfers'
import { Route as DashboardReportsIndexRouteImport } from './routes/_dashboard.reports.index'
import { Route as DashboardReportsCashRouteImport } from './routes/_dashboard.reports.cash'
import { Route as DashboardReportsComplianceRouteImport } from './routes/_dashboard.reports.compliance'
import { Route as DashboardReportsCustomersRouteImport } from './routes/_dashboard.reports.customers'
import { Route as DashboardReportsInventoryRouteImport } from './routes/_dashboard.reports.inventory'
import { Route as DashboardReportsProfitabilityRouteImport } from './routes/_dashboard.reports.profitability'
import { Route as DashboardReportsRegistersRouteImport } from './routes/_dashboard.reports.registers'
import { Route as DashboardReportsSalesRouteImport } from './routes/_dashboard.reports.sales'
import { Route as DashboardSalesIndexRouteImport } from './routes/_dashboard.sales.index'
import { Route as DashboardShiftsIndexRouteImport } from './routes/_dashboard.shifts.index'
import { Route as DashboardShiftsShiftIdRouteImport } from './routes/_dashboard.shifts.$shiftId'
import { Route as DashboardCatalogBrandsIndexRouteImport } from './routes/_dashboard.catalog.brands.index'
import { Route as DashboardCatalogBrandsItemRouteImport } from './routes/_dashboard.catalog.brands.$item'
import { Route as DashboardCatalogClassificationsIndexRouteImport } from './routes/_dashboard.catalog.classifications.index'
import { Route as DashboardCatalogClassificationsItemRouteImport } from './routes/_dashboard.catalog.classifications.$item'
import { Route as DashboardCatalogPricingIndexRouteImport } from './routes/_dashboard.catalog.pricing.index'
import { Route as DashboardCatalogPricingItemRouteImport } from './routes/_dashboard.catalog.pricing.$item'
import { Route as DashboardCatalogProductsIndexRouteImport } from './routes/_dashboard.catalog.products.index'
import { Route as DashboardCatalogProductsSelectedItemRouteImport } from './routes/_dashboard.catalog.products.$selectedItem'
import { Route as DashboardCatalogProductsNewRouteImport } from './routes/_dashboard.catalog.products.new'
import { Route as DashboardCatalogStrainsIndexRouteImport } from './routes/_dashboard.catalog.strains.index'
import { Route as DashboardCatalogStrainsItemRouteImport } from './routes/_dashboard.catalog.strains.$item'
import { Route as DashboardCatalogSuppliersIndexRouteImport } from './routes/_dashboard.catalog.suppliers.index'
import { Route as DashboardCatalogSuppliersItemRouteImport } from './routes/_dashboard.catalog.suppliers.$item'
import { Route as DashboardCatalogTagsIndexRouteImport } from './routes/_dashboard.catalog.tags.index'
import { Route as DashboardCatalogTagsItemRouteImport } from './routes/_dashboard.catalog.tags.$item'
import { Route as DashboardDevicesAgentsIndexRouteImport } from './routes/_dashboard.devices.agents.index'
import { Route as DashboardDevicesAgentsItemRouteImport } from './routes/_dashboard.devices.agents.$item'
import { Route as DashboardDevicesJobsIndexRouteImport } from './routes/_dashboard.devices.jobs.index'
import { Route as DashboardDevicesJobsItemRouteImport } from './routes/_dashboard.devices.jobs.$item'
import { Route as DashboardDevicesPrintersIndexRouteImport } from './routes/_dashboard.devices.printers.index'
import { Route as DashboardDevicesPrintersItemRouteImport } from './routes/_dashboard.devices.printers.$item'
import { Route as DashboardDevicesTemplatesIndexRouteImport } from './routes/_dashboard.devices.templates.index'
import { Route as DashboardDevicesTemplatesItemRouteImport } from './routes/_dashboard.devices.templates.$item'
import { Route as DashboardInventoryAdjustmentsIndexRouteImport } from './routes/_dashboard.inventory.adjustments.index'
import { Route as DashboardInventoryAdjustmentsItemRouteImport } from './routes/_dashboard.inventory.adjustments.$item'
import { Route as DashboardInventoryPackagesIndexRouteImport } from './routes/_dashboard.inventory.packages.index'
import { Route as DashboardInventoryPackagesItemRouteImport } from './routes/_dashboard.inventory.packages.$item'
import { Route as DashboardInventoryReconciliationIndexRouteImport } from './routes/_dashboard.inventory.reconciliation.index'
import { Route as DashboardInventoryReconciliationItemRouteImport } from './routes/_dashboard.inventory.reconciliation.$item'
import { Route as DashboardInventoryStockIndexRouteImport } from './routes/_dashboard.inventory.stock.index'
import { Route as DashboardInventoryStockItemRouteImport } from './routes/_dashboard.inventory.stock.$item'
import { Route as DashboardInventoryTransfersIndexRouteImport } from './routes/_dashboard.inventory.transfers.index'
import { Route as DashboardInventoryTransfersItemRouteImport } from './routes/_dashboard.inventory.transfers.$item'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DashboardRoute = DashboardRouteImport.update({
            id: '/_dashboard',getParentRoute: () => rootRouteImport
          })
const ImpersonateRoute = ImpersonateRouteImport.update({
            id: '/impersonate',path: '/impersonate',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const DashboardAnalyticsRoute = DashboardAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => DashboardRoute
          })
const DashboardAuditRoute = DashboardAuditRouteImport.update({
            id: '/audit',path: '/audit',getParentRoute: () => DashboardRoute
          })
const DashboardCustomersRoute = DashboardCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => DashboardRoute
          })
const DashboardDashboardRoute = DashboardDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => DashboardRoute
          })
const DashboardDeliveriesRoute = DashboardDeliveriesRouteImport.update({
            id: '/deliveries',path: '/deliveries',getParentRoute: () => DashboardRoute
          })
const DashboardDevicesRoute = DashboardDevicesRouteImport.update({
            id: '/devices',path: '/devices',getParentRoute: () => DashboardRoute
          })
const DashboardDynamicIslandRoute = DashboardDynamicIslandRouteImport.update({
            id: '/dynamic-island',path: '/dynamic-island',getParentRoute: () => DashboardRoute
          })
const DashboardReportsRoute = DashboardReportsRouteImport.update({
            id: '/reports',path: '/reports',getParentRoute: () => DashboardRoute
          })
const DashboardSalesRoute = DashboardSalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => DashboardRoute
          })
const DashboardShiftsRoute = DashboardShiftsRouteImport.update({
            id: '/shifts',path: '/shifts',getParentRoute: () => DashboardRoute
          })
const DashboardTerminalRoute = DashboardTerminalRouteImport.update({
            id: '/terminal',path: '/terminal',getParentRoute: () => DashboardRoute
          })
const AuthSlugRoute = AuthSlugRouteImport.update({
            id: '/auth/$slug',path: '/auth/$slug',getParentRoute: () => rootRouteImport
          })
const PayLinkTokenRoute = PayLinkTokenRouteImport.update({
            id: '/pay-link/$token',path: '/pay-link/$token',getParentRoute: () => rootRouteImport
          })
const DashboardAnalyticsIndexRoute = DashboardAnalyticsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsCashRoute = DashboardAnalyticsCashRouteImport.update({
            id: '/cash',path: '/cash',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsComplianceRoute = DashboardAnalyticsComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsCustomersRoute = DashboardAnalyticsCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsInventoryRoute = DashboardAnalyticsInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsProfitabilityRoute = DashboardAnalyticsProfitabilityRouteImport.update({
            id: '/profitability',path: '/profitability',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardAnalyticsSalesRoute = DashboardAnalyticsSalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => DashboardAnalyticsRoute
          })
const DashboardCatalogBrandsRoute = DashboardCatalogBrandsRouteImport.update({
            id: '/catalog/brands',path: '/catalog/brands',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogClassificationsRoute = DashboardCatalogClassificationsRouteImport.update({
            id: '/catalog/classifications',path: '/catalog/classifications',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogPricingRoute = DashboardCatalogPricingRouteImport.update({
            id: '/catalog/pricing',path: '/catalog/pricing',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogProductsRoute = DashboardCatalogProductsRouteImport.update({
            id: '/catalog/products',path: '/catalog/products',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogStrainsRoute = DashboardCatalogStrainsRouteImport.update({
            id: '/catalog/strains',path: '/catalog/strains',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogSuppliersRoute = DashboardCatalogSuppliersRouteImport.update({
            id: '/catalog/suppliers',path: '/catalog/suppliers',getParentRoute: () => DashboardRoute
          })
const DashboardCatalogTagsRoute = DashboardCatalogTagsRouteImport.update({
            id: '/catalog/tags',path: '/catalog/tags',getParentRoute: () => DashboardRoute
          })
const DashboardCustomersIndexRoute = DashboardCustomersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCustomersRoute
          })
const DashboardCustomersItemRoute = DashboardCustomersItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCustomersRoute
          })
const DashboardDevicesAgentsRoute = DashboardDevicesAgentsRouteImport.update({
            id: '/agents',path: '/agents',getParentRoute: () => DashboardDevicesRoute
          })
const DashboardDevicesJobsRoute = DashboardDevicesJobsRouteImport.update({
            id: '/jobs',path: '/jobs',getParentRoute: () => DashboardDevicesRoute
          })
const DashboardDevicesPrintersRoute = DashboardDevicesPrintersRouteImport.update({
            id: '/printers',path: '/printers',getParentRoute: () => DashboardDevicesRoute
          })
const DashboardDevicesTemplatesRoute = DashboardDevicesTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => DashboardDevicesRoute
          })
const DashboardInventoryAdjustmentsRoute = DashboardInventoryAdjustmentsRouteImport.update({
            id: '/inventory/adjustments',path: '/inventory/adjustments',getParentRoute: () => DashboardRoute
          })
const DashboardInventoryPackagesRoute = DashboardInventoryPackagesRouteImport.update({
            id: '/inventory/packages',path: '/inventory/packages',getParentRoute: () => DashboardRoute
          })
const DashboardInventoryReconciliationRoute = DashboardInventoryReconciliationRouteImport.update({
            id: '/inventory/reconciliation',path: '/inventory/reconciliation',getParentRoute: () => DashboardRoute
          })
const DashboardInventoryStockRoute = DashboardInventoryStockRouteImport.update({
            id: '/inventory/stock',path: '/inventory/stock',getParentRoute: () => DashboardRoute
          })
const DashboardInventoryTransfersRoute = DashboardInventoryTransfersRouteImport.update({
            id: '/inventory/transfers',path: '/inventory/transfers',getParentRoute: () => DashboardRoute
          })
const DashboardReportsIndexRoute = DashboardReportsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsCashRoute = DashboardReportsCashRouteImport.update({
            id: '/cash',path: '/cash',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsComplianceRoute = DashboardReportsComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsCustomersRoute = DashboardReportsCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsInventoryRoute = DashboardReportsInventoryRouteImport.update({
            id: '/inventory',path: '/inventory',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsProfitabilityRoute = DashboardReportsProfitabilityRouteImport.update({
            id: '/profitability',path: '/profitability',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsRegistersRoute = DashboardReportsRegistersRouteImport.update({
            id: '/registers',path: '/registers',getParentRoute: () => DashboardReportsRoute
          })
const DashboardReportsSalesRoute = DashboardReportsSalesRouteImport.update({
            id: '/sales',path: '/sales',getParentRoute: () => DashboardReportsRoute
          })
const DashboardSalesIndexRoute = DashboardSalesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardSalesRoute
          })
const DashboardShiftsIndexRoute = DashboardShiftsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardShiftsRoute
          })
const DashboardShiftsShiftIdRoute = DashboardShiftsShiftIdRouteImport.update({
            id: '/$shiftId',path: '/$shiftId',getParentRoute: () => DashboardShiftsRoute
          })
const DashboardCatalogBrandsIndexRoute = DashboardCatalogBrandsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogBrandsRoute
          })
const DashboardCatalogBrandsItemRoute = DashboardCatalogBrandsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogBrandsRoute
          })
const DashboardCatalogClassificationsIndexRoute = DashboardCatalogClassificationsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogClassificationsRoute
          })
const DashboardCatalogClassificationsItemRoute = DashboardCatalogClassificationsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogClassificationsRoute
          })
const DashboardCatalogPricingIndexRoute = DashboardCatalogPricingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogPricingRoute
          })
const DashboardCatalogPricingItemRoute = DashboardCatalogPricingItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogPricingRoute
          })
const DashboardCatalogProductsIndexRoute = DashboardCatalogProductsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogProductsRoute
          })
const DashboardCatalogProductsSelectedItemRoute = DashboardCatalogProductsSelectedItemRouteImport.update({
            id: '/$selectedItem',path: '/$selectedItem',getParentRoute: () => DashboardCatalogProductsRoute
          })
const DashboardCatalogProductsNewRoute = DashboardCatalogProductsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => DashboardCatalogProductsRoute
          })
const DashboardCatalogStrainsIndexRoute = DashboardCatalogStrainsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogStrainsRoute
          })
const DashboardCatalogStrainsItemRoute = DashboardCatalogStrainsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogStrainsRoute
          })
const DashboardCatalogSuppliersIndexRoute = DashboardCatalogSuppliersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogSuppliersRoute
          })
const DashboardCatalogSuppliersItemRoute = DashboardCatalogSuppliersItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogSuppliersRoute
          })
const DashboardCatalogTagsIndexRoute = DashboardCatalogTagsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardCatalogTagsRoute
          })
const DashboardCatalogTagsItemRoute = DashboardCatalogTagsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardCatalogTagsRoute
          })
const DashboardDevicesAgentsIndexRoute = DashboardDevicesAgentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDevicesAgentsRoute
          })
const DashboardDevicesAgentsItemRoute = DashboardDevicesAgentsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardDevicesAgentsRoute
          })
const DashboardDevicesJobsIndexRoute = DashboardDevicesJobsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDevicesJobsRoute
          })
const DashboardDevicesJobsItemRoute = DashboardDevicesJobsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardDevicesJobsRoute
          })
const DashboardDevicesPrintersIndexRoute = DashboardDevicesPrintersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDevicesPrintersRoute
          })
const DashboardDevicesPrintersItemRoute = DashboardDevicesPrintersItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardDevicesPrintersRoute
          })
const DashboardDevicesTemplatesIndexRoute = DashboardDevicesTemplatesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardDevicesTemplatesRoute
          })
const DashboardDevicesTemplatesItemRoute = DashboardDevicesTemplatesItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardDevicesTemplatesRoute
          })
const DashboardInventoryAdjustmentsIndexRoute = DashboardInventoryAdjustmentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInventoryAdjustmentsRoute
          })
const DashboardInventoryAdjustmentsItemRoute = DashboardInventoryAdjustmentsItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardInventoryAdjustmentsRoute
          })
const DashboardInventoryPackagesIndexRoute = DashboardInventoryPackagesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInventoryPackagesRoute
          })
const DashboardInventoryPackagesItemRoute = DashboardInventoryPackagesItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardInventoryPackagesRoute
          })
const DashboardInventoryReconciliationIndexRoute = DashboardInventoryReconciliationIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInventoryReconciliationRoute
          })
const DashboardInventoryReconciliationItemRoute = DashboardInventoryReconciliationItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardInventoryReconciliationRoute
          })
const DashboardInventoryStockIndexRoute = DashboardInventoryStockIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInventoryStockRoute
          })
const DashboardInventoryStockItemRoute = DashboardInventoryStockItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardInventoryStockRoute
          })
const DashboardInventoryTransfersIndexRoute = DashboardInventoryTransfersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DashboardInventoryTransfersRoute
          })
const DashboardInventoryTransfersItemRoute = DashboardInventoryTransfersItemRouteImport.update({
            id: '/$item',path: '/$item',getParentRoute: () => DashboardInventoryTransfersRoute
          })





const DashboardAnalyticsRouteChildren = {
  DashboardAnalyticsCashRoute: DashboardAnalyticsCashRoute,DashboardAnalyticsComplianceRoute: DashboardAnalyticsComplianceRoute,DashboardAnalyticsCustomersRoute: DashboardAnalyticsCustomersRoute,DashboardAnalyticsInventoryRoute: DashboardAnalyticsInventoryRoute,DashboardAnalyticsProfitabilityRoute: DashboardAnalyticsProfitabilityRoute,DashboardAnalyticsSalesRoute: DashboardAnalyticsSalesRoute,DashboardAnalyticsIndexRoute: DashboardAnalyticsIndexRoute
}

const DashboardAnalyticsRouteWithChildren = DashboardAnalyticsRoute._addFileChildren(DashboardAnalyticsRouteChildren)




const DashboardCustomersRouteChildren = {
  DashboardCustomersItemRoute: DashboardCustomersItemRoute,DashboardCustomersIndexRoute: DashboardCustomersIndexRoute
}

const DashboardCustomersRouteWithChildren = DashboardCustomersRoute._addFileChildren(DashboardCustomersRouteChildren)




const DashboardDevicesAgentsRouteChildren = {
  DashboardDevicesAgentsItemRoute: DashboardDevicesAgentsItemRoute,DashboardDevicesAgentsIndexRoute: DashboardDevicesAgentsIndexRoute
}

const DashboardDevicesAgentsRouteWithChildren = DashboardDevicesAgentsRoute._addFileChildren(DashboardDevicesAgentsRouteChildren)




const DashboardDevicesJobsRouteChildren = {
  DashboardDevicesJobsItemRoute: DashboardDevicesJobsItemRoute,DashboardDevicesJobsIndexRoute: DashboardDevicesJobsIndexRoute
}

const DashboardDevicesJobsRouteWithChildren = DashboardDevicesJobsRoute._addFileChildren(DashboardDevicesJobsRouteChildren)




const DashboardDevicesPrintersRouteChildren = {
  DashboardDevicesPrintersItemRoute: DashboardDevicesPrintersItemRoute,DashboardDevicesPrintersIndexRoute: DashboardDevicesPrintersIndexRoute
}

const DashboardDevicesPrintersRouteWithChildren = DashboardDevicesPrintersRoute._addFileChildren(DashboardDevicesPrintersRouteChildren)




const DashboardDevicesTemplatesRouteChildren = {
  DashboardDevicesTemplatesItemRoute: DashboardDevicesTemplatesItemRoute,DashboardDevicesTemplatesIndexRoute: DashboardDevicesTemplatesIndexRoute
}

const DashboardDevicesTemplatesRouteWithChildren = DashboardDevicesTemplatesRoute._addFileChildren(DashboardDevicesTemplatesRouteChildren)



const DashboardDevicesRouteChildren = {
  DashboardDevicesAgentsRoute: DashboardDevicesAgentsRouteWithChildren,DashboardDevicesJobsRoute: DashboardDevicesJobsRouteWithChildren,DashboardDevicesPrintersRoute: DashboardDevicesPrintersRouteWithChildren,DashboardDevicesTemplatesRoute: DashboardDevicesTemplatesRouteWithChildren
}

const DashboardDevicesRouteWithChildren = DashboardDevicesRoute._addFileChildren(DashboardDevicesRouteChildren)




const DashboardReportsRouteChildren = {
  DashboardReportsCashRoute: DashboardReportsCashRoute,DashboardReportsComplianceRoute: DashboardReportsComplianceRoute,DashboardReportsCustomersRoute: DashboardReportsCustomersRoute,DashboardReportsInventoryRoute: DashboardReportsInventoryRoute,DashboardReportsProfitabilityRoute: DashboardReportsProfitabilityRoute,DashboardReportsRegistersRoute: DashboardReportsRegistersRoute,DashboardReportsSalesRoute: DashboardReportsSalesRoute,DashboardReportsIndexRoute: DashboardReportsIndexRoute
}

const DashboardReportsRouteWithChildren = DashboardReportsRoute._addFileChildren(DashboardReportsRouteChildren)




const DashboardSalesRouteChildren = {
  DashboardSalesIndexRoute: DashboardSalesIndexRoute
}

const DashboardSalesRouteWithChildren = DashboardSalesRoute._addFileChildren(DashboardSalesRouteChildren)




const DashboardShiftsRouteChildren = {
  DashboardShiftsShiftIdRoute: DashboardShiftsShiftIdRoute,DashboardShiftsIndexRoute: DashboardShiftsIndexRoute
}

const DashboardShiftsRouteWithChildren = DashboardShiftsRoute._addFileChildren(DashboardShiftsRouteChildren)




const DashboardCatalogBrandsRouteChildren = {
  DashboardCatalogBrandsItemRoute: DashboardCatalogBrandsItemRoute,DashboardCatalogBrandsIndexRoute: DashboardCatalogBrandsIndexRoute
}

const DashboardCatalogBrandsRouteWithChildren = DashboardCatalogBrandsRoute._addFileChildren(DashboardCatalogBrandsRouteChildren)




const DashboardCatalogClassificationsRouteChildren = {
  DashboardCatalogClassificationsItemRoute: DashboardCatalogClassificationsItemRoute,DashboardCatalogClassificationsIndexRoute: DashboardCatalogClassificationsIndexRoute
}

const DashboardCatalogClassificationsRouteWithChildren = DashboardCatalogClassificationsRoute._addFileChildren(DashboardCatalogClassificationsRouteChildren)




const DashboardCatalogPricingRouteChildren = {
  DashboardCatalogPricingItemRoute: DashboardCatalogPricingItemRoute,DashboardCatalogPricingIndexRoute: DashboardCatalogPricingIndexRoute
}

const DashboardCatalogPricingRouteWithChildren = DashboardCatalogPricingRoute._addFileChildren(DashboardCatalogPricingRouteChildren)




const DashboardCatalogProductsRouteChildren = {
  DashboardCatalogProductsSelectedItemRoute: DashboardCatalogProductsSelectedItemRoute,DashboardCatalogProductsNewRoute: DashboardCatalogProductsNewRoute,DashboardCatalogProductsIndexRoute: DashboardCatalogProductsIndexRoute
}

const DashboardCatalogProductsRouteWithChildren = DashboardCatalogProductsRoute._addFileChildren(DashboardCatalogProductsRouteChildren)




const DashboardCatalogStrainsRouteChildren = {
  DashboardCatalogStrainsItemRoute: DashboardCatalogStrainsItemRoute,DashboardCatalogStrainsIndexRoute: DashboardCatalogStrainsIndexRoute
}

const DashboardCatalogStrainsRouteWithChildren = DashboardCatalogStrainsRoute._addFileChildren(DashboardCatalogStrainsRouteChildren)




const DashboardCatalogSuppliersRouteChildren = {
  DashboardCatalogSuppliersItemRoute: DashboardCatalogSuppliersItemRoute,DashboardCatalogSuppliersIndexRoute: DashboardCatalogSuppliersIndexRoute
}

const DashboardCatalogSuppliersRouteWithChildren = DashboardCatalogSuppliersRoute._addFileChildren(DashboardCatalogSuppliersRouteChildren)




const DashboardCatalogTagsRouteChildren = {
  DashboardCatalogTagsItemRoute: DashboardCatalogTagsItemRoute,DashboardCatalogTagsIndexRoute: DashboardCatalogTagsIndexRoute
}

const DashboardCatalogTagsRouteWithChildren = DashboardCatalogTagsRoute._addFileChildren(DashboardCatalogTagsRouteChildren)




const DashboardInventoryAdjustmentsRouteChildren = {
  DashboardInventoryAdjustmentsItemRoute: DashboardInventoryAdjustmentsItemRoute,DashboardInventoryAdjustmentsIndexRoute: DashboardInventoryAdjustmentsIndexRoute
}

const DashboardInventoryAdjustmentsRouteWithChildren = DashboardInventoryAdjustmentsRoute._addFileChildren(DashboardInventoryAdjustmentsRouteChildren)




const DashboardInventoryPackagesRouteChildren = {
  DashboardInventoryPackagesItemRoute: DashboardInventoryPackagesItemRoute,DashboardInventoryPackagesIndexRoute: DashboardInventoryPackagesIndexRoute
}

const DashboardInventoryPackagesRouteWithChildren = DashboardInventoryPackagesRoute._addFileChildren(DashboardInventoryPackagesRouteChildren)




const DashboardInventoryReconciliationRouteChildren = {
  DashboardInventoryReconciliationItemRoute: DashboardInventoryReconciliationItemRoute,DashboardInventoryReconciliationIndexRoute: DashboardInventoryReconciliationIndexRoute
}

const DashboardInventoryReconciliationRouteWithChildren = DashboardInventoryReconciliationRoute._addFileChildren(DashboardInventoryReconciliationRouteChildren)




const DashboardInventoryStockRouteChildren = {
  DashboardInventoryStockItemRoute: DashboardInventoryStockItemRoute,DashboardInventoryStockIndexRoute: DashboardInventoryStockIndexRoute
}

const DashboardInventoryStockRouteWithChildren = DashboardInventoryStockRoute._addFileChildren(DashboardInventoryStockRouteChildren)




const DashboardInventoryTransfersRouteChildren = {
  DashboardInventoryTransfersItemRoute: DashboardInventoryTransfersItemRoute,DashboardInventoryTransfersIndexRoute: DashboardInventoryTransfersIndexRoute
}

const DashboardInventoryTransfersRouteWithChildren = DashboardInventoryTransfersRoute._addFileChildren(DashboardInventoryTransfersRouteChildren)



const DashboardRouteChildren = {
  DashboardAnalyticsRoute: DashboardAnalyticsRouteWithChildren,DashboardAuditRoute: DashboardAuditRoute,DashboardCustomersRoute: DashboardCustomersRouteWithChildren,DashboardDashboardRoute: DashboardDashboardRoute,DashboardDeliveriesRoute: DashboardDeliveriesRoute,DashboardDevicesRoute: DashboardDevicesRouteWithChildren,DashboardDynamicIslandRoute: DashboardDynamicIslandRoute,DashboardReportsRoute: DashboardReportsRouteWithChildren,DashboardSalesRoute: DashboardSalesRouteWithChildren,DashboardShiftsRoute: DashboardShiftsRouteWithChildren,DashboardTerminalRoute: DashboardTerminalRoute,DashboardCatalogBrandsRoute: DashboardCatalogBrandsRouteWithChildren,DashboardCatalogClassificationsRoute: DashboardCatalogClassificationsRouteWithChildren,DashboardCatalogPricingRoute: DashboardCatalogPricingRouteWithChildren,DashboardCatalogProductsRoute: DashboardCatalogProductsRouteWithChildren,DashboardCatalogStrainsRoute: DashboardCatalogStrainsRouteWithChildren,DashboardCatalogSuppliersRoute: DashboardCatalogSuppliersRouteWithChildren,DashboardCatalogTagsRoute: DashboardCatalogTagsRouteWithChildren,DashboardInventoryAdjustmentsRoute: DashboardInventoryAdjustmentsRouteWithChildren,DashboardInventoryPackagesRoute: DashboardInventoryPackagesRouteWithChildren,DashboardInventoryReconciliationRoute: DashboardInventoryReconciliationRouteWithChildren,DashboardInventoryStockRoute: DashboardInventoryStockRouteWithChildren,DashboardInventoryTransfersRoute: DashboardInventoryTransfersRouteWithChildren
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(DashboardRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DashboardRoute: DashboardRouteWithChildren,ImpersonateRoute: ImpersonateRoute,ResetPasswordRoute: ResetPasswordRoute,AuthSlugRoute: AuthSlugRoute,PayLinkTokenRoute: PayLinkTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)